import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  apiPost, apiDelete } from "../../api/apiclient";
import { CREATE_AI_AGENT, DELETE_AI_AGENT } from "../../api/endpoints";

// Async thunk for creating AI agents
export const deployAiAgent = createAsyncThunk(
  "deployAiAgent",
  async (params, { rejectWithValue }) => {
    console.log('params',params)
    try {
       const response = await apiPost(`${CREATE_AI_AGENT}${params}/run_sandbox/`);
     
      if (response?.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

// Async thunk for deleting AI agents
export const deleteAiAgent = createAsyncThunk(
  "deleteAiAgent",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await apiDelete(`${CREATE_AI_AGENT}${slug}/delete/`);
      console.log('response',response)
      if (response?.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

const DeployAIAgentSlice = createSlice({
  name: "ai_agent",
  initialState: {
    deployAgentLoading: false,
    deployAgentError: null,
    deployAgent: null,
    taskId: null,
    deleteAgentLoading: false,
    deleteAgentError: null,
    deleteAgentSuccess: false,
  },
  reducers: {
    resetDeployAgent: (state, payload) => {
      state.deployAgentLoading = false;
      state.deployAgentError = null;
      state.deployAgent = null;
    },
    saveTaskId: (state, action) => {
      state.taskId = action.payload;
    },
    resetDeleteAgent: (state) => {
      state.deleteAgentLoading = false;
      state.deleteAgentError = null;
      state.deleteAgentSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deployAiAgent.pending, (state) => {
        state.deployAgentLoading = true;
        state.deployAgentError = null;
      })
      .addCase(deployAiAgent.fulfilled, (state, action) => {
        state.deployAgentLoading = false;
        state.deployAgent = action.payload;
      })
      .addCase(deployAiAgent.rejected, (state, action) => {
        state.deployAgentLoading = false;
        state.deployAgentError = action.payload;
      })
      .addCase(deleteAiAgent.pending, (state) => {
        state.deleteAgentLoading = true;
        state.deleteAgentError = null;
        state.deleteAgentSuccess = false;
      })
      .addCase(deleteAiAgent.fulfilled, (state, action) => {
        state.deleteAgentLoading = false;
        state.deleteAgentSuccess = true;
      })
      .addCase(deleteAiAgent.rejected, (state, action) => {
        state.deleteAgentLoading = false;
        state.deleteAgentError = action.payload;
        state.deleteAgentSuccess = false;
      });
  },
});

// Exporting the action to save form details
export const { resetDeployAgent, saveTaskId, resetDeleteAgent } = DeployAIAgentSlice.actions;

// Exporting the reducer
export default DeployAIAgentSlice.reducer;
